import { AppBreadCrumbTemplate } from '@/app/AppBreadCrumbTemplate';
import { RedirectPaths, RedirectPathsEnum } from '@/common/constants';
import { useAppSelector } from '@/hooks/store';
import OwnMaterialsTransitionImage from '@/images/placeholders/own-materials-transition.svg';
import { selectCurrentAccount } from '@/store/features/account';
import { AppBreadCrumb } from '@/ui/breadcrumb';
import { AppButton } from '@/ui/buttons';
import { FlexContainer } from '@/ui/styled-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { LoadingPage } from '../LoadingPage';

const StyledPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100%;
`;

const StyledContainer = styled(FlexContainer)`
  background-color: var(--beige-main);
  border-radius: var(--medium-border-radius);
  padding: var(--big-padding);
  text-align: center;

  h2 {
    font-size: var(--heading-medium-font-size);
    line-height: var(--heading-medium-line-height);
    font-weight: 700;
    margin-bottom: var(--small-padding);
  }

  p {
    line-height: var(--medium-line-height);
    font-weight: 500;
    max-width: 560px;
    margin-bottom: var(--big-padding);
  }
`;

const StyledImage = styled.img`
  width: 100%;
  max-width: 682px;
  height: auto;
  margin-bottom: var(--big-padding);
`;

export const OwnMaterialsTransitionPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const currentAccount = useAppSelector(selectCurrentAccount);

  if (!currentAccount) {
    return <LoadingPage message={t('generic.loading')} />;
  }

  const pathItems = [
    {
      label: currentAccount?.name,
      url: !currentAccount?.isSystem
        ? RedirectPaths[RedirectPathsEnum.ACCOUNT](currentAccount?.id as string)
        : RedirectPaths[RedirectPathsEnum.EDIT_ACCOUNT](currentAccount?.id),
      template: AppBreadCrumbTemplate,
    },
    {
      label: t('custom.materials'),
      template: AppBreadCrumbTemplate,
    },
  ];

  return (
    <StyledPageWrapper>
      <AppBreadCrumb model={pathItems} />
      <FlexContainer justify="space-between" className="mb-4">
        <h1 className="mb-0">{t('custom.materials')}</h1>
      </FlexContainer>
      <StyledContainer
        direction="column"
        flex="1"
        align="center"
        justify="center"
      >
        <StyledImage src={OwnMaterialsTransitionImage} alt="" />
        <h2>{t('materials.transition.title')}</h2>
        <p>{t('materials.transition.body')}</p>
        <AppButton
          label={t('materials.transition.cta')}
          onClick={() => navigate(RedirectPaths[RedirectPathsEnum.COURSES]())}
        />
      </StyledContainer>
    </StyledPageWrapper>
  );
};
